/**
 * Created by zhaoxu on 2018/4/19.
 */
import Vue from 'vue';
import ElementUI from 'element-ui';
// import QxUI from '@/components/common-ui'
import promiseFinally from 'promise.prototype.finally';
import Vuex from 'vuex'

promiseFinally.shim();
Vue.use(ElementUI, { size: 'small' });
Vue.use(Vuex);
// Vue.use(QxUI);

const docs = require.context('./plugins/', true, /plugin-.*\.js$/);
docs.keys().forEach(item => {
  Vue.use(docs(item).default);
});
